import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const BookingTools = Loadable(lazy(() => import('../inbox/BookingTools')));
const Inbox = Loadable(lazy(() => import('../inbox/Inbox')));

const chatRoutes = [
  { path: '/dashboard/inbox', element: <Inbox /> },
  { path: '/dashboard/inbox/booking-tools', element: <BookingTools />, auth: authRoles.admin },
];

export default chatRoutes;
